import React from 'react';
import {
	makeStyles,
	Box,
	Grid,
	MenuItem,
	TextField as TextField2,
} from '@material-ui/core';
import { Field, Form, Formik, FieldArray } from 'formik';
import DatePicker from '@mui/lab/DatePicker';
import { TextField } from 'formik-material-ui';
import { useHistory, useLocation } from 'react-router-dom';
import TitleText from '../components/reusableComponents/TitleText';
import BodyText from '../components/reusableComponents/BodyText';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { walletBalanceAgentDispatch } from '../reducers/UserReducer';
import { toggleGSTModal } from '../reducers/UiReducer';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {
	FlightFareQuoteEtravDispatch,
	FlightFareQuoteDispatch,
	FlightAddBookingDispatch,
} from '../reducers/HomeReducer';
import { useDispatch, useSelector } from 'react-redux';
import { FlightFareQuoteTripJackDispatch } from '../reducers/TripjackReducer';
const title = ['Mr', 'Mrs','Ms','Mstr','Miss'];
const titleC = ['Mstr','Miss'];
const titleI = ['Mr','Ms','Mstr','Miss'];
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		// backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 5,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
			borderRadius: 5,
		},
	},
	InputPropsStyle: {
		// backgroundColor: 'white',
		borderRadius: 15,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: 'rgb(239, 51, 57)',
		color: 'white',
		borderRadius: 12,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: 'rgb(239, 51, 57)',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
			width: '100%',
		},
	},
	dob: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	passport: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 12,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& label': {
			fontSize: 15,
		},
		// '& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
		// 	fontSize: 14,
		// },
	},
	root2: {
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& label': {
			fontSize: 15,
		},
	},
}));
const FlightSummaryForm = ({ time }) => {
	const classes = useStyles();
	const history = useHistory();
	const location = useLocation();
	const [value, setValue] = React.useState(null);
	const [child1, setChild1] = React.useState(new Date());
	const [child2, setChild2] = React.useState(new Date());
	const [child3, setChild3] = React.useState(new Date());
	const [child4, setChild4] = React.useState(new Date());
	const [child5, setChild5] = React.useState(new Date());
	const [child6, setChild6] = React.useState(new Date());
	const [infant1, setInfant1] = React.useState(new Date());
	const [infant2, setInfant2] = React.useState(new Date());
	const [infant3, setInfant3] = React.useState(new Date());
	const [infant4, setInfant4] = React.useState(new Date());
	const [infant5, setInfant5] = React.useState(new Date());
	const [infant6, setInfant6] = React.useState(new Date());
	const { etravflightFare,selectedOrigin,selectedDepart } = useSelector((state) => state.ui);
	const { agentlogin } = useSelector((state) => state.user);
	function calculate_age(dob) {
		var diff_ms = Date.now() - dob.getTime();
		var age_dt = new Date(diff_ms);

		// return Math.abs(age_dt.getUTCFullYear() - 1970);
		let age = Math.abs(age_dt.getUTCFullYear() - 1970);
		if (age < 6) {
			alert('Please Select Valid Age');
		} else if (age > 12) {
			alert('Please Select Valid Age');
		}
		console.log('Hen', Math.abs(age_dt.getUTCFullYear() - 1970));
	}
	const dispatch = useDispatch();
	const convert = (str) => {
		var date = new Date(str),
			mnth = ('0' + (date.getMonth() + 1)).slice(-2),
			day = ('0' + date.getDate()).slice(-2);
		return [date.getFullYear(), mnth, day].join('-');
	};
	const handleFormSubmit = (data) => {
		if (location.state.OneflightData) {
			if (location.state.OneflightData.Airline_Code) {
				let formEtravFare = {
					Search_Key: location.state.IDEtrav,
					AirRepriceRequests: [
						{
							Flight_Key: location.state.OneflightData.Flight_Key,
							Fare_Id: location.state.OneflightData.Fares.Fare_Id,
						},
					],
					Customer_Mobile: data.phone,
					GST_Input: false,
					SinglePricing: true,
					agent_id:
						agentlogin && agentlogin.status === 200
							? agentlogin.result.result.id
							: 0,
				};

				dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
				dispatch(
					walletBalanceAgentDispatch(
						agentlogin &&
							agentlogin.result &&
							agentlogin.result.result &&
							agentlogin.result.result.email,
						agentlogin &&
							agentlogin.result &&
							agentlogin.result.result &&
							agentlogin.result.result.id
					)
				);
				history.push({
					pathname: '/confirmflight',
					state: {
						formData: data,
						body: location.state.body,
						// BookingData: FormData,
						OneflightData: location.state.OneflightData,
						IDTBO: location.state.IDTBO,
						IDEtrav: location.state.IDEtrav,
						orderID: location.state.orderID,
					},
				});
			} else if (location.state.OneflightData.AirlineCode) {
				let formData1 = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					agent_id:
						agentlogin && agentlogin.status === 200
							? agentlogin.result.result.id
							: 0,
				};
				let ssr = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
				};

				dispatch(FlightFareQuoteDispatch(formData1, ssr, dispatch));
				history.push({
					pathname: '/confirmflight',
					state: {
						formData: data,
						// BookingData: FormData,
						body: location.state.body,
						OneflightData: location.state.OneflightData,
						IDTBO: location.state.IDTBO,
						IDEtrav: location.state.IDEtrav,
						orderID: location.state.orderID,
					},
				});
			}else if(location.state.OneflightData.Supplier==='TJK'){
				let formData ={
					priceIds : [location.state.OneflightData.totalPriceList.id]
				  }
				  dispatch(FlightFareQuoteTripJackDispatch(formData))
				console.log("TJK")
				history.push({
					pathname: '/confirmflight',
					state: {
						formData: data,
						body: location.state.body,
						// BookingData: FormData,
						OneflightData: location.state.OneflightData,
						orderID: location.state.orderID,
					},
				});
			}
		}else if (location.state.selectedonward) {
			if (
			  location.state.selectedonward[0]?.Airline_Code &&
			  location.state.selectedReturn[0]?.Airline_Code
			) {
			  let formEtravFare = {
				Search_Key: location.state.IDEtrav,
				AirRepriceRequests: [
				  {
					Flight_Key: location.state.selectedonward[0]?.Flight_Key,
					Fare_Id: location.state.selectedonward[0]?.Fares.Fare_Id,
				  },
				  {
					Flight_Key: location.state.selectedReturn[0]?.Flight_Key,
					Fare_Id: location.state.selectedReturn[0]?.Fares.Fare_Id,
				  },
				],
				Customer_Mobile: data.phone,
				GST_Input: false,
				SinglePricing: true,
				agent_id: agentlogin
				  ? agentlogin.status === 200
					? agentlogin?.result.result.id
					: 0
				  : 0,
			  };
	  
			  dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
			  history.push({
				pathname: "/confirmflight",
				state: {
				  formData: data,
				  orderID: location.state.orderID,
				  returnBody: location.state.returnBody,
				  IDTBO: location.state.IDTBO,
				  IDEtrav: location.state.IDEtrav,
				//   BookingData: FormData,
				  // orderID: location.state.orderID,
				  selectedonward: location.state.selectedonward,
				  selectedReturn: location.state.selectedReturn,
				},
			  });
			} else if (
			  location.state.selectedonward[0]?.Airline_Code &&
			  location.state.selectedReturn[0]?.AirlineCode
			) {
			  if (location.state.selectedonward[0]?.Airline_Code) {
				let formEtravFare = {
				  Search_Key: location.state.IDEtrav,
				  AirRepriceRequests: [
					{
					  Flight_Key: location.state.selectedonward[0]?.Flight_Key,
					  Fare_Id: location.state.selectedonward[0]?.Fares.Fare_Id,
					},
				  ],
				  Customer_Mobile: data.phone,
				  GST_Input: false,
				  SinglePricing: true,
				  agent_id: agentlogin
					? agentlogin.status === 200
					  ? agentlogin?.result.result.id
					  : 0
					: 0,
				};
	  
				dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
				history.push({
				  pathname: "/confirmflight",
				  state: {
					formData: data,
					orderID: location.state.orderID,
					returnBody: location.state.returnBody,
					IDTBO: location.state.IDTBO,
					IDEtrav: location.state.IDEtrav,
					// BookingData: FormData,
					// orderID: location.state.orderID,
					selectedonward: location.state.selectedonward,
					selectedReturn: location.state.selectedReturn,
				  },
				});
			  }
			  if (location.state.selectedReturn[0]?.AirlineCode) {
				let formData1 = {
				  TraceId: location.state.IDTBO,
				  ResultIndex: location.state.selectedReturn[0].ResultIndex,
				  agent_id: agentlogin
					? agentlogin.status === 200
					  ? agentlogin?.result.result.id
					  : 0
					: 0,
				};
	  
				dispatch(FlightFareQuoteDispatch(formData1));
			  }
			} else if (
			  location.state.selectedReturn[0]?.Airline_Code &&
			  location.state.selectedonward[0]?.AirlineCode
			) {
			  if (location.state.selectedReturn[0].Airline_Code) {
				let formEtravFare = {
				  Search_Key: location.state.IDEtrav,
				  AirRepriceRequests: [
					{
					  Flight_Key: location.state.selectedReturn[0].Flight_Key,
					  Fare_Id: location.state.selectedReturn[0].Fares.Fare_Id,
					},
				  ],
				  Customer_Mobile: data.phone,
				  GST_Input: false,
				  SinglePricing: true,
				  agent_id: agentlogin
					? agentlogin.status === 200
					  ? agentlogin?.result.result.id
					  : 0
					: 0,
				};
	  
				dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
				history.push({
				  pathname: "/confirmflight",
				  state: {
					formData: data,
					orderID: location.state.orderID,
					returnBody: location.state.returnBody,
					IDTBO: location.state.IDTBO,
					IDEtrav: location.state.IDEtrav,
					// BookingData: FormData,
					// orderID: location.state.orderID,
					selectedonward: location.state.selectedonward,
					selectedReturn: location.state.selectedReturn,
				  },
				});
			  }
			  if (location.state.selectedonward[0]?.AirlineCode) {
				let formData1 = {
				  TraceId: location.state.IDTBO,
				  ResultIndex: location.state.selectedonward[0].ResultIndex,
				  agent_id: agentlogin
					? agentlogin.status === 200
					  ? agentlogin?.result.result.id
					  : 0
					: 0,
				};
	  
				dispatch(FlightFareQuoteDispatch(formData1));
			  }
			} else if (
			  location.state.selectedonward[0]?.AirlineCode &&
			  location.state.selectedReturn[0]?.AirlineCode
			) {
			  let formData1 = {
				TraceId: location.state.IDTBO,
				ResultIndex: location.state.selectedonward[0].ResultIndex,
				agent_id: agentlogin
				  ? agentlogin.status === 200
					? agentlogin?.result.result.id
					: 0
				  : 0,
			  };
			  let formData2 = {
				TraceId: location.state.IDTBO,
				ResultIndex: location.state.selectedReturn[0].ResultIndex,
				agent_id: agentlogin
				  ? agentlogin.status === 200
					? agentlogin?.result.result.id
					: 0
				  : 0,
			  };
	  
			  dispatch(FlightFareQuoteDispatch(formData1));
			  dispatch(FlightFareQuoteDispatch(formData2));
			  history.push({
				pathname: "/confirmflight",
				state: {
				  formData: data,
				  orderID: location.state.orderID,
				  returnBody: location.state.returnBody,
				  IDTBO: location.state.IDTBO,
				  IDEtrav: location.state.IDEtrav,
				  selectedonward: location.state.selectedonward,
				  selectedReturn: location.state.selectedReturn,
				},
			  });
			} else if(location.state.selectedonward[0]?.Supplier==='TJK'&&location.state.selectedReturn[0]?.Supplier==='TJK'){
				let formData ={
					priceIds : [location.state.selectedonward[0].totalPriceList.id,location.state.selectedReturn[0].totalPriceList.id]
				  }
				  dispatch(FlightFareQuoteTripJackDispatch(formData))
				  history.push({
					pathname: "/confirmflight",
					state: {
					  formData: data,
					  orderID: location.state.orderID,
					  returnBody: location.state.returnBody,
					//   IDTBO: location.state.IDTBO,
					//   IDEtrav: location.state.IDEtrav,
					  // BookingData: FormData,
					  // orderID: location.state.orderID,
					  selectedonward: location.state.selectedonward,
					  selectedReturn: location.state.selectedReturn,
					},
				  });
			}else if(location.state.selectedonward[0]?.Supplier==='TJK'&&location.state.selectedReturn[0]?.AirlineCode){
				if(location.state.selectedonward[0]?.Supplier==='TJK'){
					let formData ={
						priceIds : [location.state.selectedonward[0].totalPriceList.id]
					  }
					  dispatch(FlightFareQuoteTripJackDispatch(formData))
				}
				if(location.state.selectedReturn[0]?.AirlineCode){
					let formData1 = {
						TraceId: location.state.IDTBO,
						ResultIndex: location.state.selectedReturn[0].ResultIndex,
						agent_id: agentlogin
						  ? agentlogin.status === 200
							? agentlogin?.result.result.id
							: 0
						  : 0,
					  };
			
					  dispatch(FlightFareQuoteDispatch(formData1));
				}
				  history.push({
					pathname: "/confirmflight",
					state: {
					  formData: data,
					  orderID: location.state.orderID,
					  returnBody: location.state.returnBody,
					//   IDTBO: location.state.IDTBO,
					//   IDEtrav: location.state.IDEtrav,
					  // BookingData: FormData,
					  // orderID: location.state.orderID,
					  selectedonward: location.state.selectedonward,
					  selectedReturn: location.state.selectedReturn,
					},
				  });
			}
		  }else if(location.state.intFlight){
			let formData1 = {
				TraceId: location.state.IDTBO,
				ResultIndex: location.state.intFlight.ResultIndex,
				agent_id:
					agentlogin && agentlogin.status === 200
						? agentlogin.result.result.id
						: 0,
			};
			let ssr = {
				TraceId: location.state.IDTBO,
				ResultIndex: location.state.intFlight.ResultIndex,
			};

			dispatch(FlightFareQuoteDispatch(formData1, ssr, dispatch));
			history.push({
				pathname: '/confirmflight',
				state: {
					formData: data,
					// BookingData: FormData,
					body: location.state.body,
					returnBody: location.state.returnBody,
					intFlight: location.state.intFlight,
					IDTBO: location.state.IDTBO,
					IDEtrav: location.state.IDEtrav,
					orderID: location.state.orderID,
				},
			});
		  }

		console.log(data);
		console.log('Value', value);
		console.log('ForData', FormData);
	};
	const adult = location.state.body
		? location.state.body.AdultCount
		: location.state.returnBody.AdultCount;
	const child = location.state.body
		? location.state.body.ChildCount
		: location.state.returnBody.ChildCount;
	const infant = location.state.body
		? location.state.body.InfantCount
		: location.state.returnBody.InfantCount;
	const ar = [];
	const ar2 = [];
	const ar3 = [];
	for (let i = 1; i <= adult; i++) {
		ar.push({});
	}
	for (let i = 1; i <= child; i++) {
		ar2.push({});
	}
	for (let i = 1; i <= infant; i++) {
		ar3.push({});
	}
	console.log('first', ar);

	return (
		<>
			<Formik
				initialValues={{
					adults: ar,
					childs: ar2,
					infants: ar3,
				}}
				onSubmit={handleFormSubmit}>
				{(formik) => (
					<Form>
						<Box
							className={classes.root}
							style={{
								background: 'white',
								padding: '10px 15px',
								border: '1px solid #e6e6e6',
								marginTop: '10px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							<Grid
								container
								spacing={2}
								alignItems='center'
								style={{ marginTop: 20, alignItems: 'baseline' }}>
								<Grid item xs={12} lg={6}>
									<Field
										component={TextField}
										name='email'
										type='email'
										variant='outlined'
										// error={errors.email}
										label='Email ID'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
								</Grid>
								<Grid item xs={12} lg={6}>
									<Field
										component={TextField}
										name='phone'
										type='number'
										variant='outlined'
										// error={errors.phone}
										label='Mobile No.'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
								</Grid>
							</Grid>
						</Box>
						<FieldArray
							name='adult'
							render={(arrayHelpers) => {
								return (
									<div>
										{formik.values.adults.map((adult, index) => (
											<>
												<Box
													className={classes.root}
													style={{
														background: 'white',
														padding: '10px 15px',
														border: '1px solid #e6e6e6',
														marginTop: '10px',
														boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
														borderRadius: '5px',
													}}>
													<div>{`Enter the Detail of Adult.${index + 1}`}</div>
													
													<Grid
														container
														spacing={2}
														alignItems='center'
														style={{ marginTop: 20, alignItems: 'baseline' }}>
														<Grid
															item
															xs={12}
															sm={6}
															lg={4}
															className={classes.root2}
															style={{ alignItems: 'center' }}>
															<Field
																component={TextField}
																select
																name={`adult.${index}.title`}
																type='text'
																variant='outlined'
																label='Select Title'
																// error={errors.titleA1}
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	className: classes.inputPropsStyle,
																}}>
																{title.map((item, index) => (
																	<MenuItem key={index} value={item}>
																		{item}
																	</MenuItem>
																))}
															</Field>
														</Grid>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`adult.${index}.firstname`}
																type='text'
																// error={errors.first_nameA1}
																variant='outlined'
																label='Enter First Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`adult.${index}.lastname`}
																type='text'
																// error={errors.last_nameA1}
																variant='outlined'
																label='Enter Last Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														{selectedOrigin.country_code==='IN'&&selectedDepart.country_code==='IN'?'':<>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`adult.${index}.passportnumber`}
																type='text'
																// error={errors.last_nameA1}
																variant='outlined'
																label='Enter Passport Number'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`adult.${index}.expiry`}
																type='date'
																// error={errors.last_nameA1}
																variant='outlined'
																label='Select Expiry Date'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`adult.${index}.dob`}
																type='date'
																// error={errors.last_nameA1}
																variant='outlined'
																label='Select DOB'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														</>}
													</Grid>
												</Box>
											</>
										))}
									
									</div>
								);
							}}
						/>
						<FieldArray
							name='child'
							render={(arrayHelpers) => {
								return (
									<div>
										{formik.values.childs.map((child, index) => (
											<>
												<Box
													className={classes.root}
													style={{
														background: 'white',
														padding: '10px 15px',
														border: '1px solid #e6e6e6',
														marginTop: '10px',
														boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
														borderRadius: '5px',
													}}>
													<div>{`Enter the Detail of Child.${index + 1}`}</div>
													{/* <Field
														disabled
														type='text'
														name={`chil.${index}.firsName`}
														value={chil.firsName}
													/>
													<Field type='date' name={`chil.${index}.date`} /> */}
													<Grid
														container
														spacing={2}
														alignItems='center'
														style={{ marginTop: 20, alignItems: 'baseline' }}>
														<Grid
															item
															xs={12}
															sm={6}
															lg={3}
															className={classes.root2}
															style={{ alignItems: 'center' }}>
															<Field
																component={TextField}
																select
																name={`child.${index}.title`}
																type='text'
																variant='outlined'
																label='Select Title'
																// error={errors.titleC1}
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	className: classes.inputPropsStyle,
																}}>
																{titleC.map((item, index) => (
																	<MenuItem key={index} value={item}>
																		{item}
																	</MenuItem>
																))}
															</Field>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`child.${index}.firstname`}
																type='text'
																variant='outlined'
																// error={errors.first_nameC1}
																label='Enter First Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`child.${index}.lastname`}
																type='text'
																variant='outlined'
																// error={errors.last_nameC1}
																label='Enter Last Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`child.${index}.dob`}
																type='date'
																variant='outlined'
																// error={errors.last_nameC1}
																label='Select DOB'
																className={classes.selectField}
																// style={{color:'lightgrey'}}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														{selectedOrigin.country_code==='IN'&&selectedDepart.country_code==='IN'?'':<>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`child.${index}.passportnumber`}
																type='text'
																// error={errors.last_nameA1}
																variant='outlined'
																label='Enter Passport Number'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`child.${index}.expiry`}
																type='date'
																// error={errors.last_nameA1}
																variant='outlined'
																label='Select Expiry Date'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														
														</>}
													</Grid>
												</Box>
											</>
										))}
									</div>
								);
							}}
						/>
						<FieldArray
							name='infant'
							render={(arrayHelpers) => {
								return (
									<div>
										{formik.values.infants.map((infant, index) => (
											<>
												<Box
													className={classes.root}
													style={{
														background: 'white',
														padding: '10px 15px',
														border: '1px solid #e6e6e6',
														marginTop: '10px',
														boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
														borderRadius: '5px',
													}}>
													<div>{`Enter the Detail of Infant.${index + 1}`}</div>
													{/* <Field
														disabled
														type='text'
														name={`chil.${index}.firsName`}
														value={chil.firsName}
													/>
													<Field type='date' name={`chil.${index}.date`} /> */}
													<Grid
														container
														spacing={2}
														alignItems='center'
														style={{ marginTop: 20, alignItems: 'baseline' }}>
														<Grid
															item
															xs={12}
															sm={6}
															lg={3}
															className={classes.root2}
															style={{ alignItems: 'center' }}>
															<Field
																component={TextField}
																select
																name={`infant.${index}.title`}
																type='text'
																variant='outlined'
																label='Select Title'
																// error={errors.titleC1}
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	className: classes.inputPropsStyle,
																}}>
																{titleI.map((item, index) => (
																	<MenuItem key={index} value={item}>
																		{item}
																	</MenuItem>
																))}
															</Field>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`infant.${index}.firstname`}
																type='text'
																variant='outlined'
																// error={errors.first_nameC1}
																label='Enter First Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`infant.${index}.lastname`}
																type='text'
																variant='outlined'
																// error={errors.last_nameC1}
																label='Enter Last Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`infant.${index}.dob`}
																type='date'
																variant='outlined'
																// placeholder="Select DOB"
																// error={errors.last_nameC1}
																label='Select DOB'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														{selectedOrigin.country_code==='IN'&&selectedDepart.country_code==='IN'?'':<>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`infant.${index}.passportnumber`}
																type='text'
																// error={errors.last_nameA1}
																variant='outlined'
																label='Enter Passport Number'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`infant.${index}.expiry`}
																type='date'
																// error={errors.last_nameA1}
																variant='outlined'
																label='Select Expiry Date'
																// value=''
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														
														</>}
													</Grid>
												</Box>
											</>
										))}
									</div>
								);
							}}
						/>
						<Grid container spacing={4} alignItems='center' style={{marginBottom:20}}>
							<Grid item xs={3}></Grid>
							<Grid item xs={12} lg={4}>
								<button
									type='submit'
									className={classes.createButton}
									style={{ marginTop: 10, fontSize: 16,cursor:'pointer' }}>
									Continue
								</button>
							</Grid>
							<Grid item xs={4}></Grid>
						</Grid>
					</Form>
				)}
			</Formik>
		</>
	);
};

export default FlightSummaryForm;
